/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ActivateBambooHRInput = {
    bambooDomain?: string | null | undefined;
    bambooApiKey?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type ActivateBambooHRMutationVariables = {
    input: ActivateBambooHRInput;
};
export type ActivateBambooHRMutationResponse = {
    readonly activateBambooHR: {
        readonly company: {
            readonly bambooHREnabled: boolean | null;
        } | null;
    } | null;
};
export type ActivateBambooHRMutation = {
    readonly response: ActivateBambooHRMutationResponse;
    readonly variables: ActivateBambooHRMutationVariables;
};



/*
mutation ActivateBambooHRMutation(
  $input: ActivateBambooHRInput!
) {
  activateBambooHR(input: $input) {
    company {
      bambooHREnabled
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateBambooHRInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHREnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "activateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "activateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ActivateBambooHRMutation",
    "operationKind": "mutation",
    "text": "mutation ActivateBambooHRMutation(\n  $input: ActivateBambooHRInput!\n) {\n  activateBambooHR(input: $input) {\n    company {\n      bambooHREnabled\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0103a64b434db6fa83d7c81207b5ad85';
export default node;
